import { useEffect, useState } from "react";
import "./BackgroundSlider.css";

const BackgroundSlider = () => {
  const images = [
    "https://global-herbs.net/wp-content/uploads/2024/10/various-spices-grains-laid-out-marketplace-table-scaled.jpg",
    "https://global-herbs.net/wp-content/uploads/2024/10/global-herbs34-scaled.jpg",
    "https://global-herbs.net/wp-content/uploads/2024/10/global-herbs-6-scaled.jpg",
    "https://global-herbs.net/wp-content/uploads/2024/10/global-herbs-3.jpg",
    "https://global-herbshttps://global-herbs.net/wp-content/uploads/2024/10/global-herbs12.png.net/wp-content/uploads/2024/10/global-herbs2.webp",
    "https://global-herbs.net/wp-content/uploads/2024/10/global-herbs.jpg",
    "",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000); // مدة الانتقال

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="slider-container">
      {images.map((img, i) => (
        <div
          key={i}
          className={`slide ${i === index ? "active" : ""}`}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}
    </div>
  );
};

export default BackgroundSlider;

